import { IAMCallResponse, IUserMetadata } from '@/store/auth/_state'
import { GetCashiersAttributes, ApiV1SessionsDataAttributes } from '@/api'
import { jwtDecode } from 'jwt-decode'

export const commonRoles = [
  { role: 'assistenza', isAdmin: true },
  { role: 'cassiera', isAdmin: false },
  { role: 'gerente', isAdmin: false },
  { role: 'magazziniere', isAdmin: false },
  { role: 'posmobile', isAdmin: false },
  { role: 'rdv', isAdmin: false },
  { role: 'retailops', isAdmin: false },
]

export const formatUserRole = (role?: string) => {
  if (role) {
    return role.replace('POS:::', '')
  }
  return ''
}

export const isUserAdmin = (role?: string) => {
  if (!role) {
    return false
  }
  return (
    commonRoles.find((r) => r.role === role.toLowerCase())?.isAdmin || false
  )
}

export interface UserApiV1SessionsDataAttributes extends ApiV1SessionsDataAttributes {
  name: string
  surname: string
  username: string
}

export const getUserInfofromLogin = (
  data?: UserApiV1SessionsDataAttributes,
): IUserMetadata => {
  if (!data) {
    return { username: 'NA', surname: 'NA', name: 'NA' }
  }

  return {
    username: data.username,
    name: data.name,
    surname: data.surname || data.username,
  }
}

export const getUserInfofromIAM = (iam: IAMCallResponse): IUserMetadata => {
  const data = jwtDecode(iam.id_token) as any

  return {
    username: data.internal_id, // there is no username from iam
    name: data.given_name,
    surname: data.family_name,
    email: data.email,
    uid: data.internal_id,
  }
}

export const getCashierFromUID = (
  user: IUserMetadata,
  cashiersList: GetCashiersAttributes[],
): GetCashiersAttributes => {
  const cashier = cashiersList.filter((el) => el.venditrice === user.uid)
  if (cashier.length > 0) {
    return cashier[0]
  }
}

export const getUserFullname = (
  user: IUserMetadata,
  cashiersList: GetCashiersAttributes[],
): string => {
  if (user.uid) {
    const cashier = getCashierFromUID(user, cashiersList)
    if (cashier && cashier.descrizione) {
      return cashier.descrizione
    }
  }
  // for common users we use just the name
  // because usually the surname is the store code
  if (
    commonRoles.find((r) => r.role === user.username?.toLowerCase()) &&
    user.name
  ) {
    return user.name
  }

  // then we try to concatenate a valid username
  if (user.name || user.surname) {
    const name = user.name || ''
    const surname = user.surname || ''
    return `${name} ${surname}`
  }
  // otherwise ... return the username itself
  return user.username
}

export const getUserInitials = (
  user: IUserMetadata,
  cashiersList: GetCashiersAttributes[],
) => {
  if (user.uid) {
    const cashier = getCashierFromUID(user, cashiersList)
    if (cashier && cashier.descrizione) {
      const initials = cashier.descrizione.split(' ').map((el) => el[0])

      if (initials.length > 2) {
        return `${initials[0]}${initials[initials.length - 1]}`
      }

      return initials.join('')
    }
  }
  // for common users we use just the name
  // because usually the surname is the store code
  if (commonRoles.find((r) => r.role === user.username?.toLowerCase())) {
    return user.username.slice(0, 2)
  }

  const initials = [user.name?.[0], user.surname?.[0]].filter(Boolean).join('')
  return initials || user.username.slice(0, 1)
}
